<template>
<div style="padding: 16px !important;background: #F0F2F5 !important;">
  <el-container>
    <el-container style="border-left:1px solid #E7EAEC" :style="conheight">
      <!-- <h3 class="flow_table_title">常用语列表</h3> -->
      <collapse-search>
        <el-row>
          <el-col :span="6">
            <el-button
              type="primary"
              size="small"
              @click="operating('0', 'add')"
              icon="el-icon-plus"
              style="margin-left:0"
              >{{ $t("common.add") }}</el-button
            >
            <!--      <el-button type="danger" size="small" @click="remove" icon="el-icon-delete" style="margin-left:3px;">删除</el-button>-->
            <eip-popconfirm-button
              type="danger"
              title="确定删除吗？"
              icon="el-icon-delete"
              @onConfirm="remove"
              style="margin-left:3px;"
              >{{ $t("common.delete") }}</eip-popconfirm-button
            >
          </el-col>
          <el-col :span="18">
            <el-input
              size="small"
              style="width:380px"
              clearable
              :placeholder="$t('approvalItem.commonLanguage')"
              prefix-icon="el-icon-search"
              v-model="tableData"
            ></el-input>
            <el-button
              style="margin-left: 20px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >{{ $t("common.search") }}</el-button
            >
            <el-button size="small" icon="el-icon-refresh" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </collapse-search>
      <el-main class="approval-item__content">
        <el-table
          :data="rows"
          stripe
          border
          style="width: 100%;"
          header-cell-class-name="todo-header-row"
          row-class-name="todo-row"
          size="medium"
          height="100%"
          :default-sort="{ prop: 'updateTime', order: 'ascending' }"
          v-loading.fullscreen.lock="fullscreenLoading"
          @selection-change="handleChecked"
        >
          <el-table-column
            type="selection"
            sortable
            width="40"
          ></el-table-column>
          <el-table-column
            type="index"
            sortable
            width="45"
            :label="$t('common.seq')"
          ></el-table-column>
          <el-table-column
            prop="expression"
            :label="$t('approvalItem.commonLanguage')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            width="200"
            label="更新时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop=""
            :label="$t('common.operation')"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                @click="operating(scope.row.id, 'edit')"
                size="small"
                icon="el-icon-edit"
                plain
                >{{ $t("common.modify") }}</el-button
              >
              <el-button
                @click="operating(scope.row.id, 'get')"
                size="small"
                icon="el-icon-tickets"
                plain
                >{{ $t("common.detail") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-row type="flex" justify="end">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EipPopconfirmButton from "@/components/eipControl/EipPopconfirmButton";

export default {
  name: "approvalItemList",
  components: {
    EipPopconfirmButton,
  },
  data() {
    return {
      tableData: "",
      fullscreenLoading: true,
      checkBoxData: [],
      conheight:{ height:'' },
    };
  },
  computed: mapState({
    rows: (state) => state.approvalItem.rows,
    pagination: (state) => state.approvalItem.pagination,
    total: (state) => state.approvalItem.total,
  }),
  methods: {
    getHeight(){
      this.conheight.height=window.innerHeight-65+'px';
      window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
    },
    remove() {
      var ids = [];
      if (this.checkBoxData && this.checkBoxData.length > 0) {
        for (let index = 0; index < this.checkBoxData.length; index++) {
          ids.push(this.checkBoxData[index].id);
        }
      }
      //数组去重
      //this.checkBoxData = Array.from(new Set(this.checkBoxData));
      if (ids.length > 0) {
        this.$store
          .dispatch("approvalItem/remove", ids.join(","))
          .then((res) => {
            this.search();
          });
      } else {
        this.$message({
          message: "请选择要删除的数据",
          type: "warning",
        });
      }
    },
    handleChecked(value) {
      this.checkBoxData = value;
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("approvalItem/setPaginationPageNum", 1);
      }
      let querys = []; //查询条件
      let queryFilter = {};
      let pageBean = { pageBean: this.pagination };
      if (this.tableData == "") {
        this.$store.dispatch("approvalItem/getlistJson", pageBean).then(() => {
          this.fullscreenLoading = false;
        });
      } else {
        querys = [
          {
            property: "EXPRESSION_",
            value: this.tableData,
            group: "main",
            operation: "LIKE",
            relation: "OR",
          },
        ];
        queryFilter = { pageBean: this.pagination, querys };
        this.$store
          .dispatch("approvalItem/getlistJson", queryFilter)
          .then(() => {
            this.fullscreenLoading = false;
          });
      }
    },
    //重置
    reset() {
      this.tableData = "";
      this.search("find");
    },
    operating(id, action) {
      var title =
        action == "edit"
          ? "编辑常用语"
          : action == "add"
          ? "添加常用语"
          : "查看常用语";
      if (action == "add") {
        this.$router.push("/approvalItem/approvalItemAdd");
      } else if (action == "edit") {
        this.$router.push("/approvalItem/approvalItemEdit/" + id);
      } else {
        this.$router.push("/approvalItem/approvalItemGet/" + id);
      }
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("approvalItem/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("approvalItem/setPaginationPageNum", currentPage);
      this.search();
    },
  },
  created() {
    //页面高度设置
    window.addEventListener('resize', this.getHeight);
    this.getHeight();

    let pagination = { pageBean: { page: 1, pageSize: 20, showTotal: true } };
    this.$store.dispatch("approvalItem/getlistJson", pagination).then(() => {
      this.fullscreenLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .el-table::before{
  display: none;
}

.el-table--group::after, .el-table--border::after{
  display: none;
}

/deep/.el-table--border th{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}


/deep/ .el-table{
  border: 0px !important;
  tr{
    max-height: 48px !important;
    height: 48px !important;
    line-height: 48px !important;
    td{
      padding: 0px !important;
      border-top: 0px solid #F0F2F5 !important;
      border-bottom: 1px solid #F0F2F5 !important;
      border-left: 0px solid #F0F2F5 !important;
      border-right: 0px solid #F0F2F5 !important;
    }
  }
  th{
    border: 0px;
  }
}


/deep/.el-table--border tr:hover > td{
    background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    }
    // .taskName{
    //   color: #1890FF !important;
    // }
}

// /deep/.el-table--border tr {
//   border-top: 0px solid #F0F2F5;
//   border-bottom: 1px solid #F0F2F5;
//   border-left: 0px solid #F0F2F5;
//   border-right: 0px solid #F0F2F5;
// }



//x3样式 隔行变色
/*
/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}

/deep/.el-table--border tr:hover > td{
    background-color:#fdfdaf !important;
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 0px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

*/
.list_main_content {
  padding: 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/ .todo-subject-read,
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 14px !important;
}




/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 0px solid #ededed;
}

.todo-subject,
.todo-subject-read {
  cursor: pointer;
}


/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.todo-subject {
  cursor: pointer;
}
.approval-item__content{
  padding-top: 0;
}
.todo-subject {
  color: $--theme-color;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}


.expand-collapse__search{
  margin: 16px 8px 16px 24px;
}

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}
/deep/ .el-main{
  padding: 0 24px 0px 24px !important;
}

/deep/ .expand-collapse__search .el-collapse-item__header{
  padding-right: 24px;
}
/deep/ .el-container{
  .el-main{
    padding: 0px;
  }
}
/deep/ .el-table::before{
  display: none;
}
/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 24px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    height: 32px !important;
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 
</style>
